import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Aria from 'formvalidation/es6/plugins/Aria';

(function (fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    [].forEach.call(document.querySelectorAll('.free-trial'), (trial) => {
        const submit = trial.querySelector('button[type="submit"]');
        formValidation(trial, {
            plugins: {
                aria: new Aria(),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                declarative: new Declarative({
                    html5Input: true,
                }),
                trigger: new Trigger({
                    event: {
                        email: 'blur',
                    },
                }),
            },
        }).on('core.form.valid', () => {
            submit.disabled = true;
        });

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                submit.disabled = false;
            }
        });
    });
    [].forEach.call(document.querySelectorAll('.top_email'), (field) => {
        field.addEventListener('keyup', function() {
            const tmpval = this.value;
            if (tmpval == '') {
                this.classList.remove('not-empty');
            } else {
                this.classList.add('not-empty');
            }
        });
    });
}));
